import React, { useEffect } from 'react';
import { Hero } from '../components/renacida/Hero';
import { Gancho } from '../components/renacida/Gancho';
import { PainAgitation } from '../components/renacida/PainAgitation';
import { WhyItFails } from '../components/renacida/WhyItFails';
import { Introducing } from '../components/renacida/Introducing';
import { Modules } from '../components/renacida/Modules';
import { Benefits } from '../components/renacida/Benefits';
import { Testimonials } from '../components/renacida/Testimonials';
import { Bonuses } from '../components/renacida/Bonuses';
import { Guarantee } from '../components/renacida/Guarantee';
import { Urgency } from '../components/renacida/Urgency';
import { FinalCTA } from '../components/renacida/FinalCTA';
import { SocialPhrases } from '../components/renacida/SocialPhrases';
import { Footer } from '../components/renacida/Footer';
import { useScreenInit } from '../useScreenInit';
import { initMetaPixel } from '../components/renacida/metaPixel';
export function Renacida() {
  useScreenInit();
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen bg-cream font-sans text-brown selection:bg-rose/20 selection:text-rose-dark overflow-x-hidden" data-id="element-215">
      <Hero data-id="element-216" />
      <Gancho data-id="element-217" />
      <PainAgitation data-id="element-218" />
      <WhyItFails data-id="element-219" />
      <Introducing data-id="element-220" />
      <Modules data-id="element-221" />
      <Benefits data-id="element-222" />
      <Testimonials data-id="element-223" />
      <Bonuses data-id="element-224" />
      <Guarantee data-id="element-225" />
      <Urgency data-id="element-226" />
      <FinalCTA data-id="element-227" />
      <SocialPhrases data-id="element-228" />
      <Footer data-id="element-229" />
    </main>;
}